import React from 'react';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { MOCKUP_URL, valueStack } from '../../data/content';
export function ValueStackSection() {
  return <section id="offer" className="bg-brand-navy px-5 py-14 text-white sm:py-20" data-id="element-139" data-mp="3kr6bao7b15yf">
      <div className="mx-auto max-w-6xl" data-id="element-140" data-mp="3oqomgs9bq2o2">
        <SectionHeading tone="dark" title="Everything You Need to Stop Starting From Zero." data-id="element-141" data-mp="2s1pap39j6ir4" />

        <div className="mt-10 grid items-center gap-10 lg:grid-cols-[1.1fr_1fr]" data-id="element-142" data-mp="2s4236acx0bif">
          <img src={MOCKUP_URL} alt="Astrologer Ready complete bundle" loading="lazy" className="mx-auto w-full max-w-2xl object-contain drop-shadow-[0_30px_60px_rgba(0,0,0,0.5)]" data-id="element-143" data-mp="2x2wiv3fl5jyb" />

          <div className="rounded-3xl border border-white/10 bg-brand-night/70 p-6 shadow-2xl shadow-black/30 sm:p-8" data-id="element-144" data-mp="gcob1o9yj3cw">
            <ul className="divide-y divide-white/10" role="list" data-id="element-145" data-mp="la81rnnud8lq">
              {valueStack.map((item, index) => <li key={item} className="flex items-center gap-3 py-3 text-base font-bold" data-id="element-146" data-mp="lzmxdy42abu1" data-mpi={index}>
                  <span className={`flex h-6 w-6 flex-none items-center justify-center rounded-full ${index === 0 ? 'bg-brand-violet text-white' : 'bg-brand-violet/20 text-brand-lilac'}`} data-id="element-147" data-mp="h2d9wo08ga8u">
                    <PlusIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-148" data-mp="71ulrh1my7l4" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div id="checkout" className="mt-6 scroll-mt-8 border-t border-white/10 pt-6 text-center" data-id="element-149" data-mp="3ufeyubpwubdy">
              <p className="text-sm font-black uppercase tracking-[0.14em] text-brand-lilac" data-id="element-150" data-mp="3pg2ebxmihgej">Complete Astrologer Ready System</p>
              <p className="mt-2 text-base font-bold text-white/50 line-through" data-id="element-151" data-mp="3kjbzfdmg0qup">Regular Value: 69 USD</p>
              <p className="mt-2 font-display text-3xl font-bold leading-tight sm:text-4xl" data-id="element-152" data-mp="3fi61n1dxedeb">
                Get everything today for only <span className="text-brand-lilac" data-id="element-153" data-mp="3bjgista4c3na">19 USD</span>
              </p>
              <p className="mt-2 text-sm font-bold text-white/75" data-id="element-154" data-mp="30unxq586tmsy">One payment. Instant digital access.</p>
            </div>

            <CtaButton target="checkout" label="Get Instant Access to Astrologer Ready — 19 USD" className="mt-6" data-id="element-155" data-mp="2rval53oroi40" />
          </div>
        </div>
      </div>
    </section>;
}